import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Spinner } from "react-bootstrap";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import supabase from "../../supabase";
import axios from 'axios';
import "./DashboardArtisan.css";

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title);

const DashboardArtisan = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchArtisanAndStats = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) throw new Error("Utilisateur non authentifié.");

        const { data: artisanProfile, error: artisanError } = await supabase
          .from('artisans')
          .select('id')
          .eq('profile_id', user.id)
          .single();

        if (artisanError || !artisanProfile) throw new Error("Profil artisan non trouvé.");

        const artisanId = artisanProfile.id;
        const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/analytics/stats/${artisanId}`);
        
        if (response.data.success) {
          setStats(response.data.stats);
        } else {
          throw new Error("Impossible de récupérer les statistiques.");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchArtisanAndStats();
  }, []);

  const chartData = {
    labels: ['Vues du profil', 'Clics site web', 'Clics téléphone', 'Clics email'],
    datasets: [
      {
        label: 'Interactions (30 derniers jours)',
        data: [
          stats?.profile_impression || 0,
          stats?.website_click || 0,
          stats?.phone_click || 0,
          stats?.email_click || 0,
        ],
        backgroundColor: 'rgba(255, 140, 0, 0.6)',
        borderColor: 'rgba(255, 140, 0, 1)',
        borderWidth: 1,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Résumé des interactions de votre profil',
      },
    },
  };

  if (loading) {
    return <Container className="text-center mt-5"><Spinner animation="border" variant="primary" /></Container>;
  }

  if (error) {
    return <Container className="text-center mt-5"><p className="text-danger">{error}</p></Container>;
  }

  return (
    <Container className="mt-5 dashboard-container">
      <h1 className="text-center dashboard-title">Bienvenue dans votre espace artisan</h1>

      <Row>
        <Col md={12}>
          <Card className="dashboard-card">
            <Card.Body>
              <h4 className="dashboard-card-title">Statistiques sur les 30 derniers jours</h4>
              {stats ? (
                <Row className="text-center">
                  <Col>
                    <p className="dashboard-metric">{stats.profile_impression || 0}</p>
                    <p>Vues du profil</p>
                  </Col>
                  <Col>
                    <p className="dashboard-metric">{stats.website_click || 0}</p>
                    <p>Clics sur le site web</p>
                  </Col>
                  <Col>
                    <p className="dashboard-metric">{stats.phone_click || 0}</p>
                    <p>Clics sur le téléphone</p>
                  </Col>
                  <Col>
                    <p className="dashboard-metric">{stats.email_click || 0}</p>
                    <p>Clics sur l'email</p>
                  </Col>
                </Row>
              ) : <p>Aucune donnée pour le moment.</p>}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col>
          <Card className="dashboard-card">
            <Card.Body>
               <Bar data={chartData} options={chartOptions} />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default DashboardArtisan;
